export default function getResource(label) {
    const resources = {
        backButton: 'Retour'
    };

    return resources[label];
}
